export default "__VITE_ASSET__BRvaenQX__"